import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { MatTableDataSource } from '@angular/material/table';
import { MSMETable } from '../../../../../shared/models/MSMETableModel';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
//import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { StorageService } from '../../../../../shared/services/storage.service';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonService } from '../../../../../shared/services/common.service';
import { Verifymsme } from '../../../../../shared/models/verifymsme';
import { MatSort } from '@angular/material/sort';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-verifymsme',
  templateUrl: './verifymsme.component.html',
  styleUrl: './verifymsme.component.css'
})
export class VerifymsmeComponent implements AfterViewInit, OnDestroy {

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();
  
  dataSource1!: MatTableDataSource<Verifymsme>
  displayedColumns: string[] = ['rowNum', 'createdDate', 'udyamRegistrationNumber', 'nameOfEnterprise', 'districtName', 'status', 'otherDetails']
  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  verifymsmeForm: FormGroup;
  totalRegistered: number = 0;
  pendingVerification: number = 0;
  approvedRegistration: number = 0;
  rejectedRegistration: number = 0;
  rejectedForQuery: number = 0;
  isIAUser: boolean = false; // New property to track IA User
  dataSource: any[] = []; // Your full data source
  sortedItems: any[] = [];
  //pageSize = 10;
  totalItems: number = 0; // Example total items
  currentPage: number = 1;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  itemsPerPage: number = 10;
  page = 1;
  isIAComment: boolean = false;

  allrecord: any[] = [];
  
  currentPath: any;
  //pageNumber: any = 0;
  //pageSize: any = 0;
  //MSSIDCUserName= sessionStorage.getItem('userName');
  param = {
    "pageNumber":1,
    "pageSize": 20,
    "searchText":''
  }

  DtoPagination =
    {
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": this.commonService.searchText,
    }

  constructor(private apiService: ApiService,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private router: Router,
    public commonService: CommonService) {
    this.verifymsmeForm = new FormGroup({
      search: new FormControl('')
    });
  }

  //ngOnInit(): void {
  //  this.DtoPagination.PageSize = 20;
  //  this.DtoPagination.SearchCol = this.commonService.searchText;

  //  this.currentPath = this.route.snapshot.routeConfig?.path || '';
  //  console.log('Path:', this.currentPath);
  //  if (this.currentPath.includes('ia/msmeverification')) {
  //    this.isIAComment = true;
  //  }
  //  else {
  //    this.isIAComment = false;
  //  }
  //  //sessionStorage.setItem('readonlyUsername', JSON.stringify(this.MSSIDCUserName));
  //}

  ngOnInit(): void {
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchCol = this.commonService.searchText;

    this.currentPath = this.route.snapshot.routeConfig?.path || '';
    //console.log('Path:', this.currentPath);

    if (this.currentPath.includes('ia/msmeverification')) {
      this.isIAComment = true;
      this.displayedColumns = ['rowNum', 'createdDate', 'udyamRegistrationNumber', 'nameOfEnterprise', 'districtName'];
    } else {
      this.isIAComment = false;
      this.displayedColumns = ['rowNum', 'createdDate', 'udyamRegistrationNumber', 'nameOfEnterprise', 'districtName', 'status', 'otherDetails'];
    }

    //console.log('Updated displayedColumns:', this.displayedColumns);
  }



  ngAfterViewInit() {
   
    this.loadData();
  }

  loadData() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETMSMEDetails, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp.totalRecords;
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        
        const summary = data.item1 || {};
        this.dataSource1 = data.item2 || [];
        this.totalItems = summary["totalCount"] || 0;
        this.totalRegistered = summary["totalCount"] || 0;
        this.pendingVerification = summary["pendingCount"] || 0;
        this.approvedRegistration = summary["approvedCount"] || 0;
        this.rejectedRegistration = summary["rejectedCount"] || 0;
        this.rejectedForQuery = summary["rejectedForQueryCount"] || 0;

        this.adjustPaginator();
      });
  }

  // Cleanup subscriptions when component is destroyed
  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
 

  getActionType(status: string): string {
    if (status === 'Verification Pending' || status === 'Rejected for Query') {
      return 'update';
    } else {
      return 'view';
    }
  }


  //loadData() {
  //  //debugger;
  //  if (!this.pagination) return;
  //  this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);
  //  merge(this.sort.sortChange, this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
  //    this.pagination.page)
  //    .pipe(filter(searchTerm => searchTerm != null),
  //      switchMap((searchTerm) => {
  //        if (searchTerm) {
  //          this.pagination.pageIndex = 0;
  //        }
  //        this.DtoPagination.SortColumn = this.sort.active;
  //        this.DtoPagination.SortDirection = this.sort.direction;
  //        //this.DtoPagination.SearchTerm = (searchTerm && typeof searchTerm == 'string') ? searchTerm.toString() : '';
  //        this.DtoPagination.SearchCol = this.commonService.searchText;
  //        return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETMSMEDetails, this.DtoPagination)
  //          .pipe(catchError(() => of(null)));
  //      }),
  //      map(resp => {
  //        if (resp.status) {

  //          this.length = resp.data.item1.totalCount; //resp['totalRecords'];
  //        }
  //        return resp.data;
  //      })
  //    ).subscribe(data => {
        
  //      var summary = data.item1;
  //      //this.dataSource = data.item2;
  //      this.dataSource1 = data.item2;
  //      this.length = summary['totalRecords'];
  //      this.totalItems = summary["totalCount"];
  //      this.totalRegistered = summary["totalCount"];
  //      this.pendingVerification = summary["pendingCount"];
  //      this.approvedRegistration = summary["approvedCount"];
  //      this.rejectedRegistration = summary["rejectedCount"];
  //      this.rejectedForQuery = summary["rejectedForQueryCount"]


  //      this.adjustPaginator();
  //    });
  //}

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  //LoadDetails() {

  //  // this.param.pageNumber = pageNum;
  //  //this.param.pageSize = pageSizeNum;
  //  //this.param.searchText = this.verifymsmeForm.get('search')?.value;

  //  //var param = {
  //  //  pageNumber,
  //  //  pageSize,
  //  //}

  //  this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETMSMEDetails, this.DtoPagination).subscribe(
  //    result => {
  //      if (result.status) {
          
  //        var summary = result.data.item1;
  //        this.dataSource = result.data.item2;
  //        this.dataSource1 = result.data.item2;
  //        this.length = summary['totalRecords'];
  //        this.totalItems = summary["totalCount"];
  //        this.totalRegistered = summary["totalCount"];
  //        this.pendingVerification = summary["pendingCount"];
  //        this.approvedRegistration = summary["approvedCount"];
  //        this.rejectedRegistration = summary["rejectedCount"];
  //        this.rejectedForQuery = summary["rejectedForQueryCount"]
  //      } else {

  //      }
  //    }
  //  )
   
  //}

  action(msmeUserId: string, action: string): void {

    // Implement approval logic here
    this.storageService.setTwoParams(msmeUserId, action);
    this.router.navigate(['/msmeverificationdetails']);
    //this.router.navigate(['/msmeverificationdetails', msmeUserId, action]);

  }

  verify(msmeUserId: string, action: string): void {
    // Implement rejection logic here
    this.storageService.setTwoParams(msmeUserId, action);
    this.router.navigate(['/msmeverificationdetails']);
    //this.router.navigate(['/msmeverificationdetails', msmeUserId, action]);
  }

  //sort(column: string): void {
  //  if (this.sortColumn === column) {
  //    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  //  } else {
  //    this.sortColumn = column;
  //    this.sortDirection = 'asc';
  //  }
  //  this.updateSortedItems();
  //}

  updateSortedItems(): void {
    this.sortedItems = this.apiService.sort(this.dataSource, this.sortColumn, this.sortDirection);
  }



  //sort(column: string): void {
  //  if (this.sortColumn === column) {
  //    // Toggle sort direction
  //    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  //  } else {
  //    // Set new sort column and default to ascending
  //    this.sortColumn = column;
  //    this.sortDirection = 'asc';
  //  }
  //  this.updateSortedItems();
  //}

  //updateSortedItems(): void {
  //  this.sortedItems = this.dataSource.sort((a, b) => {
  //    const compareA = a[this.sortColumn];
  //    const compareB = b[this.sortColumn];

  //    if (this.sortDirection === 'asc') {
  //      return compareA < compareB ? -1 : compareA > compareB ? 1 : 0;
  //    } else {
  //      return compareA > compareB ? -1 : compareA < compareB ? 1 : 0;
  //    }
  //  });
  //}
  pageSizeOptions: number[] = [10, 20, 50, 100];
  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;

  onPageChange(e: PageEvent) {
    
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadData();
  }

  showOtherDetail(msmeid: string): void {

    // Implement approval logic here
    sessionStorage.setItem("msmeid",msmeid);
    this.router.navigate(['/msmeotherdetails']);
    //this.router.navigate(['/msmeverificationdetails', msmeUserId, action]);

  }

  onSubmit() {
    this.loadData();
  }

  onSearchClick(searchValue: string): void {
    const searchControl = this.verifymsmeForm.get('search');


    if (searchControl?.value && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.DtoPagination.SearchCol = this.commonService.searchText;
      this.loadData();
    } else if (searchValue.trim() === '') {
      searchControl?.markAsTouched();
    } else {
      searchControl?.markAsTouched();
    }
  }

  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = this.commonService.searchText;
    this.loadData();
  }

  exportToExcel(): void {
    const fileName = 'Registered_MSME_List.xlsx';

    const DtonullPagination = {
      PageNumber: 1,    // or undefined
      PageSize: 9999999,      // or undefined
      SortColumn: "",  // example sort column
      SortDirection: "",
      SearchTerm: "",   // optional search term
      SearchCol: this.commonService.searchText,
    };

    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETMSMEDetails, DtonullPagination).subscribe(
        result => {
          if (result.status) {

            var summary = result.data.item1;
            this.allrecord = result.data.item2;
          
          }
        }
      )

    if (!this.allrecord || this.allrecord.length === 0) {
      this.toastrService.error('No data available to export.');
      return;
    }

    // Prepare the data for export based on table columns
    const excelData = this.allrecord.map((item, index) => ({
      'Sr. No': index + 1,
      'Date of Submission': item.dateofSubmission,
      'UDYAM Number': item.udyamNumber,
      'Enterprise Name': item.msmeName,
      'District Name': item.districtName,
      'Status': item.status,
    }));

    // Create a worksheet from the data
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

    // Auto-adjust column width
    worksheet['!cols'] = [
      { wch: 10 }, // Sr. No
      { wch: 20 }, // Date of Submission
      { wch: 25 }, // UDYAM Number
      { wch: 30 }, // Enterprise Name
      { wch: 20 }, // District Name
      { wch: 20 }, // Status
    ];

    // Apply borders and alignment to all cells
    const range = XLSX.utils.decode_range(worksheet['!ref']!);
    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
        if (!worksheet[cellRef]) continue;

        worksheet[cellRef].s = {
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
          alignment: { horizontal: "center", vertical: "center" },
        };
      }
    }

    // Create a workbook and append the worksheet
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Registered MSME List': worksheet },
      SheetNames: ['Registered MSME List'],
    };

    // Generate a buffer for the Excel file
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
      cellStyles: true, // Enable styles
    });

    // Save the Excel file using reusable function
    this.saveExcelFile(excelBuffer, fileName);
    this.toastrService.success('Excel exported successfully!');
  }

  // Reusable method to save Excel file
  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }


  

}
